




















import { Vue, Component } from "vue-property-decorator"

import RecipeHeader from "@/components/BaseComponents/RecipeHeader.vue"
import ImageModal from "@/components/BaseComponents/ImageModal.vue"
import LoadImage from "@/plugin/mixin/loadImage"

@Component({
	mixins: [
		LoadImage
	],
	components: {
		RecipeHeader,
		ImageModal
	}
})
export default class RecipeImages extends Vue {
	recipe!: RecipeObject;
}
